import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useState, useEffect } from "react";
import { useData } from "@pure-ptr/react";

import { useSelector } from "react-redux";
import { Formik } from "formik";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Loadable } from "../../../common";
import { RootState } from "../../../store/reducers";

import { list } from "../../../store/actions/users";
import { errorToastify } from "../../../util/toast";
import { rcmAssignmentCreateUpdateDialog } from "../../../store/actions/rcmAssignment";
import { createRcmTeam,updateRcmTeam } from "../../../store/api/rcmAssignment";

const useStyles = makeStyles((theme) => ({
    button: {
        padding: "0.25rem",
    },
   
}));



const RCMAssignmentDialog = ({
    intl,
    callBack=undefined,
}) => {
    const dispatch = useDispatch();
    const [rcmTeamData, setRcmTeamData] = useState({});
    const [rcmTeamUpdateData, setRcmTeamUpdateData] = useState({});


    const open: any = useSelector<RootState>(
            (state) => state?.rcmAssignment?.rcmAssignmentCreateUpdateDialog?.open
        );

        const rowData: any = useSelector<RootState>(
            (state) => state?.rcmAssignment?.rcmAssignmentCreateUpdateDialog?.rowData
        );


    const {
        data,
        isPending,
        error:createError,
    } = useData(async () => {
        if (Object.keys(rcmTeamData).length === 0) return;
        const rcmTeam = await createRcmTeam(rcmTeamData);
        handleClose();
        setRcmTeamData({})
        callBack()
        return rcmTeam;
    }, [rcmTeamData]);


     const {
        isPending:isPendingUpdate,
        error:errorDuringUpdate,
    } = useData(async () => {
        if (Object.keys(rcmTeamUpdateData).length === 0) return;
        const rcmTeam = await updateRcmTeam(rcmTeamUpdateData);
        handleClose();
        setRcmTeamUpdateData({})
        callBack()
        return rcmTeam;
    }, [rcmTeamUpdateData]);

    useEffect(() => {
        dispatch(list());
    }, [list]);

    useEffect(() => {
        if (!errorDuringUpdate) return;
        errorToastify(
            errorDuringUpdate?.payload?.error ||
                "Something Went Wrong !! Please Contact Administrator"
        );
    }, [errorDuringUpdate]);

        useEffect(() => {
        if (!createError) return;
        errorToastify(
            createError?.payload?.error ||
                "Something Went Wrong !! Please Contact Administrator"
        );
    }, [createError]);


    const handleClose = () => {
    dispatch(rcmAssignmentCreateUpdateDialog({ open: false, rowData: null }));
        
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            sx={{ "& .MuiPaper-root": { minWidth: "400px" } }}
        >
            <DialogTitle>RCM Team</DialogTitle>

                <Loadable loading={isPending !== null || isPendingUpdate!==null}>
                    <Formik
                        enableReinitialize={true}
                        initialValues={{
                            name:rowData?.name || ""
                        }}
                        validate={(values) => {
                            const errors: any = {};

                            if (!values.name) {
                                errors.name = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                                });
                            }
                            return errors;
                        }}
                        onSubmit={(values, {}) => {
                            const rcmTeamName=values?.name?.trim()
                            if(rowData?.id)
                            {
                            setRcmTeamUpdateData({ id:rowData?.id,...values,name:rcmTeamName});
                            return

                            }
                            setRcmTeamData({ ...values,name:rcmTeamName });
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,

                            handleSubmit,
                            setFieldValue,
                        }) => (
                            <form
                                onSubmit={handleSubmit}
                                noValidate
                                autoComplete="off"
                            >
                                <DialogContent dividers>
                                    <Grid container>

                                            <TextField
                                            required
                                                label="Name"
                                                name="name"
                                                margin="normal"
                                                value={values.name}
                                                onChange={(e)=>setFieldValue("name",e.target.value)}
                                                error={Boolean(
                                                            touched.name &&
                                                                errors.name
                                                        )}
                                                        helperText={
                                                            touched.name &&
                                                            errors.name
                                                        }
                                            />
                                    </Grid>
                                </DialogContent>
                                <DialogActions >
                                    <Button
                                        type="button"
                                        onClick={handleClose}
                                        className="mr-3"
                                        variant="outlined"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        Save
                                    </Button>
                                </DialogActions>
                            </form>
                        )}
                    </Formik>
                </Loadable>
        </Dialog>
    );
};

export default injectIntl(RCMAssignmentDialog);
